module.exports = __webpack_public_path__ + "img/box_small.840b33e9.svg";